<script setup lang="ts">
import { cn } from '@/shadcn/lib/utils'
import { AvatarFallback, type AvatarFallbackProps } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

const props = defineProps<AvatarFallbackProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>

<template>
  <AvatarFallback
    data-slot="avatar-fallback"
    v-bind="delegatedProps"
    :class="cn('tw:bg-muted tw:flex tw:size-full tw:items-center tw:justify-center tw:rounded-full', props.class)"
  >
    <slot />
  </AvatarFallback>
</template>
